import dayjs from 'dayjs'

export const formatHour = (date) => {
  // Date: 2021-12-15T17:00:03.000Z
  let parsedDate = dayjs(date).tz('America/Buenos_Aires').format('HH:mm ')
  return parsedDate // Date: 17:00
}
